import React, {useState} from "react";
import { connect } from "react-redux";
import { useForm } from "react-hook-form";


// components
import { ButtonClean, ButtonSearch } from "../../../components/buttons/buttonsActions";


// actions
import { setFilter } from "../../../redux/actions/generalActions/listActions";
import { CardBody, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import {FL_CODE, FL_DATA_BASE,} from "../../../components/i18n/formLabels";
import SelectGeneric from "../../../components/select/selectGeneric";
import {fbDatabaseProvider} from "../../../providers/fbDatabaseProvider";

const FbChildPathFilters = props => {
    const { filter } = props.listProps
    const [fbDataBaseId, setFbDataBaseId] = useState( null);
    const [resetCombos, setResetCombos] = useState(false);

    const cleanFields = () => {
        const tmpFilter = JSON.parse(JSON.stringify(filter))

        setFbDataBaseId(null);
        setResetCombos(!resetCombos);

        reset({
            code: '',
            url: '',
        });

        if(tmpFilter ){
            delete tmpFilter.code;
            delete tmpFilter.url;
            delete tmpFilter.db;
        }

        props.setFilter(tmpFilter);
    }

    // ----------------------------------------------
    //            SEARCH FILTERS FORM
    // ----------------------------------------------
    const {register, handleSubmit, reset} = useForm({
        defaultValues: {
            code: filter?.code,
            url: filter?.url,
        }
    });

    const onSubmit = (data, _) => {
        const dataFilter = { ...data }

        if (fbDataBaseId !== null)
            dataFilter.db = { id : fbDataBaseId }

        props.setFilter(dataFilter);
    };

    return <Form onSubmit={handleSubmit(onSubmit)}>
        <CardBody >
            <Row>
                <Col md="3">
                    <FormGroup>
                        <Label>{ FL_CODE }</Label>
                        <Input
                            type="text"
                            name="code"
                            placeholder={ FL_CODE }
                            innerRef={register}
                        />
                    </FormGroup>
                </Col>
                <Col md="6">
                    <FormGroup>
                        <Label>{ 'URL' }</Label>
                        <Input type="text"
                               name="url"
                               placeholder={ 'URL' }
                               innerRef={register}
                        />
                    </FormGroup>
                </Col>
                <Col md="3">
                    <FormGroup>
                        <Label>{ FL_DATA_BASE }</Label>
                        <br/>
                        <SelectGeneric
                            initialValue={ fbDataBaseId }
                            setExternalValue={ setFbDataBaseId }
                            provider={ fbDatabaseProvider }
                            resetValue={resetCombos}
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md="12" className="d-flex justify-content-center">
                    <div className="float-right">
                        <ButtonSearch/>
                        <ButtonClean onClick={() => cleanFields()}/>
                    </div>
                </Col>
            </Row>
        </CardBody>
    </Form>
}

const mapStateToProps = state => ({
    mainProps: state.mainProps,
    formProps: state.formProps,
    listProps: state.listProps,
})

const mapActionsToProps = ({
    setFilter,
})

export default connect(mapStateToProps, mapActionsToProps)(FbChildPathFilters)